import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default class About extends React.Component {
  componentWillMount() {
    document.body.classList.add('about-page');
  }

  componentWillUnmount(){
    document.body.classList.remove('about-page');
  }

  render() {
    return (
      <Container className="text-page">
        <Row className="justify-content-md-center"> 
          <Col sm="8">
            <div class="text-box">
              <h1>Authorizing your first account</h1>
              <p>When you first login the app will ask you to authorize your SoundCloud account. Enter the login details for your SC account and click on authorize.
                You are now ready to start using the app.</p>
            </div>

            <div class="text-box">
              <h1>Basic operation</h1>
              <p>SCH is a very simple web-app to use. You follow people, in return they follow you back. The followback percentage is usually never under 10%, for unestablished artists. For established artists this number greatly increases.</p>
              <p>Just check the Follow checkbox, copy the SoundCloud address (URL) of the user whose followers you want to follow, and click Start.</p>
              <p>PLEASE NOTE: Change "Schedule daily (un)following" time to close to now if you want the app to start immediately.</p>
              <p>The app will start the task every day at the time you set Scheduled time to. By default it is set to 10:00AM.</p>
              <p>The app will follow as many users per day as you set it to. The actions will be spread around 24 hours. Maximum number of users followed or unfollowed per day is 200.</p>
              <p>However, <b>NEVER follow more than 85 people per day</b>. Recently SoundCloud enforced a new stricter policy and <b>you will get temp banned if you exceed this number (error 429).</b></p>
              <p>When unfollowing, you can unfollow 200 people per day.</p>
              <p>We also recommend too all of our to go up to 2000 users followed (in 20 days for example) and then to start unfollowing and go back to 0. This seems to trigger the SC spam filters less and will ensure good operation of your SoundCloud account.</p>
              <p>The app will send you daily e-mails.</p>
              <p>The app will also send you an e-mail when you have reached the end of the remote user’s followers. This means, for example if you are following Mixmag’s followers, and the app has followed all their followers, it will send you an e-mail about this. Then you will switch the Scrape URL to something else, a new user.</p>
              <p>The best way to ensure long term operation of the app without switching Scrape URLs too often is to choose a user with a similar style to yours and with a big number of followers. You will then reach your target audience, and the app will have a big number of users to follow.</p>
            </div>

            <div class="text-box">
              <h1>Whitelist</h1>
              <p><b>If you don’t want the app to unfollow the users you followed manually, check the Whitelist option.</b></p>
            </div>

            <div class="text-box">
              <h1>Cycle mode</h1>
              <p>You can also automate switching between follow/unfollow modes, by using Cycle mode. Cycle mode just switches from follow to unfollow automatically when you hit 2K users followed. Or vice versa, it switches to follow mode from unfollow, if you started from unfollowing.</p>
              <p>In the app you have two counts: One Follow count and one Unfollow count.</p>
              <p><b>You can Unfollow 200 people per day with no issues</b>. So if you were using cycle mode; you can set Follow count to 85 (max number of daily follows allowed) and Unfollow count to 200. This way, the app can work without your maintenance for a long period of time, and also it will cycle quickly.</p> 
            </div>

            <div class="text-box">
              <h1>Linking accounts</h1>
              <p>Adding multiple accounts is easy - just click the + button right to the account selection box.</p>
              <p>You will have to purchase a 3-month subscription when you want to start activity for every linked account you added.</p>
              <p>For clients with a lot of linked accounts we can offer some bulk discounts. Contact us for more info.</p>
            </div>

            <div class="text-box">
              <h1>Unlinking accounts</h1>
              <p>Go to Profile section and click on Unlink Account.</p>
            </div>

            <div class="text-box">
              <h1>Changing password</h1>
              <p>Go to Profile section and click on Change Password</p>
            </div>

            <div class="text-box">
              <h1>Log</h1>
              <p>The log will update every 60 seconds. It will notify you at the Scheduled time that your task will begin soon.</p>
              <p>Your daily follows can be done in a few minutes (or 10-15 minutes) after scheduled time, or they can be spread around the whole day. This all depends on how many users the app must browse through to find you new users to follow, and the current server load.</p>
              <p>It is nothing unusual if your daily follows or unfollows do not happen immediately, they will all be done in the course of 24 hours, don’t worry.</p> 
            </div>
          </Col>
        </Row>
      </Container>
    )
  }
}
